
    import './styles.scoped.css';
    export default {
  "top-navigation": "awsui_top-navigation_k5dlb_o7um0_145",
  "padding-box": "awsui_padding-box_k5dlb_o7um0_178",
  "medium": "awsui_medium_k5dlb_o7um0_188",
  "narrow": "awsui_narrow_k5dlb_o7um0_188",
  "virtual": "awsui_virtual_k5dlb_o7um0_199",
  "hidden": "awsui_hidden_k5dlb_o7um0_203",
  "\t": "awsui_\t_k5dlb_o7um0_1",
  "identity": "awsui_identity_k5dlb_o7um0_215",
  "identity-link": "awsui_identity-link_k5dlb_o7um0_218",
  "no-logo": "awsui_no-logo_k5dlb_o7um0_238",
  "logo": "awsui_logo_k5dlb_o7um0_242",
  "title": "awsui_title_k5dlb_o7um0_254",
  "inputs": "awsui_inputs_k5dlb_o7um0_269",
  "search": "awsui_search_k5dlb_o7um0_277",
  "search-expanded": "awsui_search-expanded_k5dlb_o7um0_281",
  "utilities": "awsui_utilities_k5dlb_o7um0_285",
  "utility-wrapper": "awsui_utility-wrapper_k5dlb_o7um0_296",
  "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_o7um0_317",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_o7um0_322",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_o7um0_331",
  "utility-link-icon": "awsui_utility-link-icon_k5dlb_o7um0_339",
  "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_o7um0_343",
  "offset-right-none": "awsui_offset-right-none_k5dlb_o7um0_347",
  "offset-right-l": "awsui_offset-right-l_k5dlb_o7um0_351",
  "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_o7um0_355",
  "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_o7um0_360",
  "overflow-menu": "awsui_overflow-menu_k5dlb_o7um0_360",
  "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_o7um0_401",
  "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_o7um0_409",
  "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_o7um0_421",
  "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_o7um0_427",
  "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_o7um0_431",
  "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_o7um0_435",
  "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_o7um0_439",
  "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_o7um0_477",
  "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_o7um0_485",
  "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_o7um0_488",
  "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_o7um0_477",
  "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_o7um0_524",
  "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_o7um0_477",
  "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_o7um0_533",
  "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_o7um0_536",
  "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_o7um0_545",
  "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_o7um0_551",
  "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_o7um0_555",
  "icon": "awsui_icon_k5dlb_o7um0_560",
  "icon-open": "awsui_icon-open_k5dlb_o7um0_574"
};
  